export const Mode = Object.freeze({
    CHAT: 'qna',
    EXTRACTION: 'info',
});
